var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notSelected)?_c('div',{staticClass:"lang-selector",on:{"click":function($event){return _vm.changeLocale(_vm.notSelected)}}},[_c('img',{attrs:{"src":require(`@/assets/img/flags/${_vm.notSelected}.svg`)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }